import React from 'react'
import HeaderNav from './Headers/HeaderNav'
import Header from 'components/Headers/Header';
import Loader from './Loader';
const Page = ({
  children,
  title,
  className,
  border, Sticky,
  menu,
  StickFooter,
  noneHeader,
  containerClass,
  rightButton,
  onSubmit,
  loading,
  onBack,
}) => {
  if (onSubmit) {
    return <form onSubmit={onSubmit} className={`page-container ${containerClass || ''}`}>
      {!noneHeader ? <>{menu ? <Header component title={title} rightButton={rightButton} /> : <HeaderNav onBack={onBack} title={title} />}</> : null}
      {border && <div style={{ borderBottom: '1px solid #E5E5E5' }}></div>}
      {Sticky ? <Sticky /> : null}
      <div className='scroll-container'>
        <div className={`scroll-div ${className}`}>
          {children}
        </div>
      </div>
      {StickFooter ? <StickFooter /> : null}
    </form>
  }
  return (
    <>
      {!!loading && <Loader />}
      <div className={`page-container ${containerClass || ''}`}>
        {!noneHeader ? <>{menu ? <Header component title={title} rightButton={rightButton} /> : <HeaderNav onBack={onBack} title={title} />}</> : null}
        {border && <div style={{ borderBottom: '1px solid #E5E5E5' }}></div>}
        {Sticky ? <Sticky /> : null}
        <div className='scroll-container'>
          <div className={`scroll-div ${className}`}>
            {children}
          </div>
        </div>
        {StickFooter ? <StickFooter /> : null}
      </div>
    </>
  )
}

export default Page;
